import React from "react";

const CancellationPolicy = () => {
  return (
    <div>
      <h6>Cancellation and Refunds:</h6>
      <ul>
        <li>Guests may cancel their booking via the Krent website.</li>
        <li>
          Cancellations made 24 hours before check-in will incur a charge of 50%
          of the cost of one night's stay.
        </li>
        <li>
          Cancellations made 48 hours before check-in will incur a charge of 30%
          of the cost of one night's stay.
        </li>
        <li>
          For cancellations made after check-in, refunds are at the host's
          discretion. Depending on the host's policy, a fee may be charged, the
          full amount may be forfeited, or a partial refund may be provided.
        </li>
      </ul>

      <h6>Special Circumstances:</h6>
      <ul>
        <li>
          In cases of severe weather, natural disasters, or government-mandated
          travel restrictions, full refunds or credits for future stays may be
          offered on a case-by-case basis.
        </li>
      </ul>

      <h6>Changing or Modifying Reservations:</h6>
      <ul>
        <li>
          Reservation dates may be changed, subject to availability and any
          applicable rate differences. Additional charges may apply for changes
          made within the cancellation period.
        </li>
      </ul>

      <h6>How to Cancel:</h6>
      <ul>
        <li>
          Guests can cancel their reservation by logging into their Krent
          account and following the cancellation instructions.
        </li>
        <li>Guests may also cancel by contacting support at 09118008008.</li>
      </ul>

      <h6>Refund Processing:</h6>
      <ul>
        <li>
          Refunds will be processed within 7 business days from the date of
          cancellation. Processing times may vary depending on the payment
          method and financial institution.
        </li>
      </ul>

      <h6>Contact Us:</h6>
      <ul>
        <li>
          For assistance with reservations or cancellations, please contact our
          support team at 09118008008.
        </li>
      </ul>

      <p>
        <strong>Note:</strong> This cancellation policy applies to bookings made
        directly through the Krent platform.
      </p>
    </div>
  );
};

export default CancellationPolicy;
